export function getMockData() {
  var localParameters = {};
  localParameters.dealerId = 6082;
  // Use QA Bearer Token
  localParameters.bearerToken = "";
  localParameters.isLocal = true;
  localParameters.categoryName = "calltracking";
  localParameters.groupName = 0;
  return localParameters;
}